import React from "react";
import css from "./Button.module.css";

import cn from "classnames";

type Props = {
    className?: string;
    variant?: "primary" | "secondary" | "text" | "icon";
    onClick?: () => void;
    disabled?: boolean;
    isLoading?: boolean;
    size?: "small" | "medium";
};

export const Button: React.FC<React.PropsWithChildren<Props>> = ({
    children,
    className,
    variant = "primary",
    onClick,
    disabled = false,
    size = "medium",
    isLoading = false,
}) => {
    return (
        <button
            className={cn(css.main, css[variant], css[size], className, isLoading && css.loader)}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    );
};
